import { withRHFController } from './withRHFController';

import {
  Autocomplete,
  Select,
  type AutocompleteProps,
  type SelectProps,
} from '../core/combobox';
import {
  Checkbox,
  PasswordInput,
  PinInput,
  Radio,
  TextInput,
  type CheckboxProps,
  type PasswordInputProps,
  type PinInputProps,
  type RadioProps,
  type TextInputProps,
} from '../core/inputs';
import {
  DatePicker,
  DatePickerInput,
  type DatePickerInputProps,
  type DatePickerProps,
} from '../dates';

export const RHFCheckbox = withRHFController<CheckboxProps>(Checkbox);

export const RHFRadio = withRHFController<RadioProps>(Radio);

export const RHFSelect = withRHFController<SelectProps>(Select);

export const RHFTextInput = withRHFController<TextInputProps>(TextInput);

export const RHFPinInput = withRHFController<PinInputProps>(PinInput);

export const RHFPasswordInput =
  withRHFController<PasswordInputProps>(PasswordInput);

export const RHFDatePickerInput =
  withRHFController<DatePickerInputProps>(DatePickerInput);

export const RHFDatePicker = withRHFController<DatePickerProps>(DatePicker);

export const RHFAutocomplete =
  withRHFController<AutocompleteProps>(Autocomplete);
